// Pathify
import { make } from 'vuex-pathify'
import { localeChanged, localize } from 'vee-validate'
import i18n from '../../i18n'
import axios from 'axios'

// Data
const state = {
  loading: false,
  locale: localStorage.getItem('cumuluslog@locale') || 'hu',
  first_day_of_week: 1,
  datepicker_settings: {
    first_day_of_week: 1,
    locale: 'hu-HU',
  },
  drawer: null,
  drawerImage: true,
  mini: false,
  notifications: [],
  currentUser: null,
  lang: {
    hu: {
      datepicker: {
        first_day_of_week: 1,
        locale: 'hu-HU',
      },
    },
    en: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'en-US',
      },
    },
    de: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'de-DE',
      },
    },
    sk: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'sk-SK',
      },
    },
    cs: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'cs-CZ',
      },
    },
    pl: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'pl-PL',
      },
    },
    fr: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'fr-FR',
      },
    },
    it: {
      datepicker: {
        first_day_of_week: 0,
        locale: 'it-IT',
      },
    },
  },
  items: [
    {
      can: 'profile-edit',
      title: 'dashboard',
      icon: '$dashboard',
      to: '/',
    },
    {
      module_on: 'address-book',
      can: 'operating-day-list',
      title: 'address_book',
      icon: '$address_book',
      to: '/address-book/',
    },
    {
      module_on: 'reservation',
      can: 'reservation-list',
      title: 'reservations',
      icon: '$reservations',
      to: '/reservations/',
    },
    {
      module_on: 'operating-day',
      can: 'operating-day-list',
      title: 'operating_days',
      icon: '$operating_days',
      to: '/operating-days/',
    },
    {
      module_on: 'daily-flight',
      can: 'daily-flight-list',
      title: 'daily_flight',
      icon: '$daily_flight',
      to: '/daily-flight/',
    },
    {
      module_on: 'work-management',
      can: 'work-management-list',
      title: 'work_management',
      icon: '$work_management',
      to: '/work-management/',
    },
    {
      module_on: 'training',
      can: 'training-administration',
      title: 'training',
      icon: '$user_training',
      items: [
        {
          title: 'planning',
          icon: '$planning',
          to: '/training/planning/',
        },
        {
          title: 'task_check',
          icon: '$task_check',
          to: '/training/task-check/',
        },
        {
          module_on: 'training-organization',
          title: 'analytics',
          icon: '$analytics',
          to: '/training/analytics/',
        },

      ],
    },
    {
      title: 'logbook',
      icon: '$logbook',
      can: 'profile-edit',
      items: [
        {
          title: 'glider',
          avatar: require('@/assets/glider.png'),
          to: '/logbook/glider',
        },
        {
          title: 'general',
          avatar: require('@/assets/general.png'),
          to: '/logbook/general',
        },
      ],
    },
    {
      module_on: 'glider|general',
      title: 'flights',
      icon: '$flights',
      items: [
        {
          module_on: 'glider',
          title: 'glider',
          avatar: require('@/assets/glider.png'),
          to: '/flight/glider',
        },
        {
          module_on: 'general',
          title: 'general',
          avatar: require('@/assets/general.png'),
          to: '/flight/general',
        },
      ],
    },
    {
      module_on: 'airport',
      title: 'airport_operations',
      icon: '$airport_operations',
      to: '/airport-operations/',
    },
    {
      title: 'administrations',
      icon: '$administrations',
      role: 'instructor,admin,financial_operator',
      items: [
        {
          can: 'user-list',
          title: 'users',
          icon: '$users',
          to: '/users/',
        },
        {
          can: 'plane-list',
          title: 'planes',
          icon: '$planes',
          to: '/planes/',
        },
        {
          can: 'report-list',
          title: 'reports',
          icon: '$reports',
          to: '/reports/',
        },
        {
          module_on: 'message-center',
          can: 'message-list',
          title: 'messages',
          icon: '$messages',
          to: '/messages/',
        },
        {
          module_on: 'financial',
          can: 'balance-list',
          title: 'balances',
          icon: '$balances',
          to: '/balances/',
        },
        {
          title: 'organizations_documents',
          icon: '$documents',
          to: '/documents/organization/',
        },
        {
          module_on: 'financial',
          can: 'transaction-list',
          title: 'transactions',
          icon: '$transactions',
          to: '/transactions/',
        },
        {
          module_on: 'membership',
          can: 'membership-list',
          title: 'memberships',
          icon: '$memberships',
          to: '/memberships/',
        },
        {
          role: 'admin',
          title: 'actions',
          icon: '$actions',
          to: '/organization/actions/',
        },
        {
          module_on: 'training',
          title: 'trainings',
          icon: '$trainings',
          to: '/settings/trainings/',
        },
        {
          role: 'admin',
          title: 'fields.edit_organization',
          icon: '$organizations',
          to: '/profile/organization-edit/',
        },
      ],
    },
    {
      module_on: 'maintenance',
      title: 'maintenance',
      icon: '$maintenance',
      can: 'component-list',
      items: [
        {
          can: 'component-list',
          title: 'components',
          icon: '$components',
          to: '/components/',
        },
        {
          can: 'component-list',
          title: 'planes',
          icon: '$planes',
          to: '/maintenance/plane-list',
        },
        {
          module_on: 'fault-report',
          title: 'plane_fault_reports',
          icon: '$plane_fault_reports',
          to: '/plane-faults',
        },
        {
          module_on: 'betatester',
          can: 'component-list',
          title: 'maintenance_operations',
          icon: '$maintenance_operations',
          to: '/maintenance/operations',
        },
      ],
    },
    {
      title: 'supervisor',
      icon: '$supervisor',
      role: 'supervisor',
      items: [
        {
          can: 'organization-list',
          title: 'organizations',
          icon: '$organizations',
          to: '/organizations/',
        },
        {
          can: 'role-list',
          title: 'roles',
          icon: '$roles',
          to: '/roles',
        },
        {
          role: 'supervisor',
          title: 'typeLists',
          icon: '$type_lists',
          to: '/type-lists',
        },
        {
          can: 'airport-list',
          title: 'airports',
          icon: '$airports',
          to: '/airports/',
        },
      ],
    },
    {
      title: 'debug',
      icon: '$debug',
      role: 'debugger',
      items: [
        {
          title: 'ogn_log',
          icon: '$ogn',
          to: '/ogn-log',
        },
        {
          title: 'change_user',
          icon: '$users',
          to: '/change',
        },
      ],
    },
    {
      title: 'Components',
      icon: 'mdi-view-comfy',
      role: 'develop',
      items: [
        {
          title: 'Multi Level Collapse',
          items: [{
            title: 'Example',
          }],
        },
        {
          title: 'Buttons',
          to: '/components/buttons/',
        },
        {
          title: 'Grid System',
          to: '/components/grid/',
        },
        {
          title: 'Tabs',
          to: '/components/tabs/',
        },
        {
          title: 'Notifications',
          to: '/components/notifications/',
        },
        {
          title: 'Icons',
          to: '/components/icons/',
        },
        {
          title: 'Typography',
          to: '/components/typography/',
        },
        {
          title: 'rforms',
          to: '/forms/regular/',
        },
        {
          title: 'eforms',
          to: '/forms/extended/',
        },
        {
          title: 'vforms',
          to: '/forms/validation/',
        },
        {
          title: 'wizard',
          to: '/forms/wizard/',
        },
        {
          title: 'rtables',
          to: '/tables/regular/',
        },
        {
          title: 'etables',
          to: '/tables/extended/',
        },
        {
          title: 'dtables',
          to: '/tables/data-tables/',
        },
        {
          title: 'datasources',
          to: '/datasources/',
        },
        {
          title: 'icons',
          to: '/components/icons/',
        },
      ],
    },
  ],
}

const mutations = {
  ...make.mutations(state),
  appLoading (isLoading) {
    if (isLoading) {
      state.appLoading += 1
    } else {
      state.appLoading -= 1
    }
  },
  set_layout (payload) {
    state.layout = payload
  },
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    actions.localeChange(null, { lang: state.locale })
  },
  appLoading (state, isLoading) {
    if (isLoading) {
      state.appLoading += 1
    } else {
      state.appLoading -= 1
    }
  },
  localeChange (context, payload) {
    // in your app code...
    console.log('Change Language: ')
    console.log(payload)
    state.locale = payload.lang
    localStorage.setItem('cumuluslog@locale', state.locale)
    i18n.locale = state.locale // locale changed
    localize(state.locale)
    localeChanged() // notify vee-validate of localization changes
    state.datepicker_settings = state.lang[state.locale].datepicker

    axios.defaults.headers.common['Accept-Language'] = state.locale

    console.log(state.payload)
    if (context !== null && !payload.login) {
      // return new Promise((resolve, reject) => {
        axios.patch('/api/profile/change-language', payload)
      // })
    }
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
